export default __webpack_public_path__ + "static/media/marker.dcaf4bf8.svg";